<template>
    <b-card-code title="المجلات العلمية" no-body>
      <b-card-body>
        <div class="d-flex justify-content-between flex-wrap">
          <!-- filter -->
          <b-form-group
            label="فلتر"
            label-cols-sm="1"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="md">
              <b-form-input
                id="filterInput"
                v-model="title"
                type="search"
                placeholder="ابحث عن.."
              />
              <b-input-group-append>
                <b-button @click="resetSearch()"> الغاء الفلتر </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-card-body>
  <div class="demo-vertical-spacing">
        <b-progress
        v-if="precentage !== 0"
          :value="precentage"
          max="100"
        />
        </div>
      <b-table
        ref="table"
        striped
        hover
        responsive
        class="position-relative"
        :per-page="perPage"
        :items="items"
        :fields="fields"
      >
        <template #cell(action)="action">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-warning"
                v-b-modal.model-e-w
                @click="eRM(action.item)"
              >
                <feather-icon icon="EditIcon" class="mr-50" />
              </b-button>
            </b-col>
            <b-col  md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-danger"
              v-b-modal.modal-center
              @click="dRM(action.item)"
            >
              <feather-icon icon="Trash2Icon" class="mr-50" />
            </b-button>
          </b-col>
          </b-dropdown>
        </template>
        
      <template #cell(logo)="logo">
        <b-avatar size="lg" :src="getImage(logo.item.image)" />
      </template>
      </b-table>
  
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            @change="check()"
            size="sm"
            inline
            :options="pageOptions"
          />
        </b-form-group>
  
        <!-- pagination -->
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
          @change="check()"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-card-body>
      <b-modal
        id="model-e-w"
        ok-title="حفظ التعديلات"
        centered
        size="lg"
        title="تعديل المجلة"
        @ok="uM"
        @hidden="rEF"
      >
      <b-form novalidate class="needs-validation" >
        <b-form-row>
          <b-col md="12">
            <label for="input-valid1">العنوان بالعربي :</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.ar_title"
              :state="editform.ar_title.length > 0"
              placeholder="العنوان بالعربي "
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">العنوان بالانكليزي :</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.en_title"
              :state="editform.en_title.length > 0"
              placeholder="العنوان بالانكليزي "
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid1">التفاصيل بالعربي:</label>
            <b-form-textarea
              id="input-invalid1"
              placeholder="التفاصيل بالعربي"
              v-model="editform.ar_description"
                rows="3"
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid1">التفاصيل بالانكليزي:</label>
            <b-form-textarea
              id="input-invalid1"
              placeholder="التفاصيل بالانكليزي"
              v-model="editform.en_description"
                rows="3"
            />
          </b-col>
            <b-col md="12">
              <label for="input-valid1">اختر صورة الوصل:</label>
              <b-form-file
              placeholder="اختر الملف او اسقطها هنا..."
              drop-placeholder="اختر الملف او اسقطها هنا..."
                v-model="editform.file"
                @change="selectFileForEditForm"
              />
            </b-col>
        </b-form-row>
      </b-form>
      </b-modal>
      <b-modal
        id="model-a-w"
        ok-title="حفظ البيانات"
        centered
        size="lg"
        title="اضافة مادة جديدة"
        @ok="aNM"
        @hidden="rF"
      >
        <b-form novalidate class="needs-validation" >
          <b-form-row>
            <b-col md="12">
            <label for="input-valid1">العنوان بالعربي :</label>
            <b-form-input
              id="input-valid1"
              v-model="form.ar_title"
              :state="form.ar_title.length > 0"
              placeholder="العنوان بالعربي "
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">العنوان بالانكليزي :</label>
            <b-form-input
              id="input-valid1"
              v-model="form.en_title"
              :state="form.en_title.length > 0"
              placeholder="العنوان بالانكليزي "
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid1">التفاصيل بالعربي:</label>
            <b-form-textarea
              id="input-invalid1"
              placeholder="التفاصيل بالعربي"
              v-model="form.ar_description"
                rows="3"
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid1">التفاصيل بالانكليزي:</label>
            <b-form-textarea
              id="input-invalid1"
              placeholder="التفاصيل بالانكليزي"
              v-model="form.en_description"
                rows="3"
            />
          </b-col>
            <b-col md="12">
              <label for="input-valid1">اختر صورة الوصل:</label>
              <b-form-file
              placeholder="اختر الملف او اسقطها هنا..."
              drop-placeholder="اختر الملف او اسقطها هنا..."
                v-model="form.file"
                @change="selectFileForForm"
              />
            </b-col>
                  </b-form-row>
        </b-form>
      </b-modal>
      <b-modal
      id="modal-center"
      centered
      title="حذف مجلة"
      @ok="dM"
      ok-title="Accept"
    >
      <b-card-text>
        هل تريد حذف هذه الحقل ؟
      </b-card-text>
    </b-modal>
    </b-card-code>
  </template>
  
  <script>
  import vSelect from "vue-select";
  import Cleave from "vue-cleave-component";
  import { filesUrl } from "@/main.js";
  import store from "@/store";
  import 'cleave.js/dist/addons/cleave-phone.us'
  import { togglePasswordVisibility } from "@core/mixins/ui/forms";
  import BCardCode from "@core/components/b-card-code/BCardCode.vue";
  import {
    BTable,
    BAvatar,
    BModal,
    BDropdown,
    BDropdownItem,
    BFormCheckboxGroup,
    BForm,
    BFormRow,
    BCol,
    VBModal,
    BBadge,
    BFormValidFeedback,
    BFormInvalidFeedback,
    BFormGroup,
    BFormCheckbox,
    BCardText,
    BFormSelect,
    BPagination,BProgress,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,BFormTextarea,
    BButton,
    BCardBody,BFormFile
  } from "bootstrap-vue";
  import Ripple from "vue-ripple-directive";
  
  export default {
    components: {
      BCardCode,
      BTable,
      BForm,
      vSelect,
      BAvatar,
      BBadge,
      BFormRow,BProgress,BFormTextarea,
      BDropdown,
      Cleave,
      BDropdownItem,
      BFormGroup,
      togglePasswordVisibility,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormCheckboxGroup,
      BFormInput,
      BInputGroupAppend,
      BButton,
      BCardBody,
      BModal,
      VBModal,
      Ripple,
      BCol,
      BFormCheckbox,
      BCardText,
      BFormValidFeedback,
      BFormInvalidFeedback,BFormFile
    },
    data() {
      return {
        precentage:0,
        teacher_id: "",
        perPage: 5,
        pageOptions: [3, 5, 10, 100],
        totalRows: 1,
        users:[],
        role: null,
        canDelete: null,
        canEdit: null,
        currentPage: 0,
        category_id: "",
        subtype_id: "",
        type_id: "",
        fromdate:"",
        todate:"",
        carency_id:"",
        carency:[],
        title: "",
        filter: null,
        date: {
            date: true,
            delimiter: '-',
            datePattern: ['Y', 'm', 'd'],
            },
        format:{
          price: {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
          },
          number: {
            creditCard: true,
          },
        },
        forwardform:{
          user_id:"",
          instorage_id:"",
          count:"",
          note:"",
          invoise:"",
          date:""
        },
        filterOn: [],
        departments: [],
          categories: [],
          types: [],
          subtypes: [],
        search:{
          categories: [],
          subtypes: [],
          types: [],
          carency:[]
        },
        fields: [
          {
            key: "full_name",
            label: "الاسم الكامل",
          },
          {
            key: "email",
            label: "الايميل",
          },
          {
            key: "subject",
            label: "الموضوع",
          },
          {
            key: "phone",
            label: "التلفون",
          },
          {
            key: "message",
            label: "المسج",
          },
        ],
        exportFields:{
            'العنوان': 'title',
              'عدد المواد': 'count',
              'سعر المادة': 'price',
              'رقم الوصل': 'invoise',
              'تاريخ الوصل': 'date',
              'ملاحظة': 'note',
              'عملة الشراء': 'carency.title',
              'نوع المادة': 'type.ar_title',
              'النوع الثانوي': 'subtype.ar_title',
        },
        exportData:[
          {
            title: "title",
            count: "count",
            price: "price",
            invoise: "invoise",
            date: "date",
            note: "note",
            carency: 'carency.title',
            type: 'type.ar_title',
            subtype: 'subtype.ar_title',
          },
        ],
        items: [],
        form: {
            ar_title: "",
            en_title: "",
            ar_description: "",
            en_description: "",
            file: ""
        },
        editform: {
            ar_title: "",
            en_title: "",
            ar_description: "",
            en_description: "",
            file: "",
          id: null
        },
        selected: [],
        selected2: [],
        options: {
          time: {
            time: true,
            timePattern: ["h", "m"],
          },
        },
      };
    },
    watch: {
      title: function (val) {
        this.gS();
      },
      "category_id": function (val) {
        if (val != null && val != "") {
          this.gS();
        }
      },
      "type_id": function (val) {
        if (val != null && val != "") {
          this.gS();
        }
      },
      "subtype_id": function (val) {
        if (val != null && val != "") {
          this.gS();
        }
      },
      "carency_id": function (val) {
        if (val != null && val != "") {
          this.gS();
        }
      },
      "fromdate": function (val) {
        if (val != null && val != "") {
          this.gS();
        }
      },
      "todate": function (val) {
        if (val != null && val != "") {
          this.gS();
        }
      },
    },
    mixins: [togglePasswordVisibility],
    computed: {
      passwordToggleIcon() {
        return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
      },
    },
    directives: {
      Ripple,
    },
    mounted() {
      this.ID(), this.gS(), this.gSM(), this.gSM1(), this.gSM2(), this.gSM3(), this.gU();
    },
    methods: {
      async gSM() {
        await this.axios
          .get(
            `types?str=true`
          )
          .then((res) => {
            this.types = [];
            this.search.types = [];
            this.types = res.data.items;
            this.search.types = res.data.items;
          })
      },
      async gSM1() {
        await this.axios
          .get(
            `subtypes`
          )
          .then((res) => {
            this.subtypes = [];
            this.search.subtypes = [];
            this.subtypes = res.data.items;
            this.search.subtypes = res.data.items;
          })
      },
      async gSM2() {
        await this.axios
          .get(
            `categories?take=100&skip=0&str=true`
          )
          .then((res) => {
            this.categories = [];
            this.search.categories = [];
            this.categories = res.data.items;
            this.search.categories = res.data.items;
          })
      },async gSM3() {
        await this.axios
          .get(
            `carency`
          )
          .then((res) => {
            this.carency = [];
            this.search.carency = [];
            this.carency = res.data.items;
            this.search.carency = res.data.items;
          })
      },
      async gU() {
        await this.axios
          .get(`users-name`)
          .then((res) => {
            this.users = [];
            this.users = res.data.items;
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "danger",
                "update failed",
                "you don't a permision to do this action ;)"
              );
            } else {
              this.errorToast();
            }
          });
      },
      async uM() {
        let data = new FormData();
        data.append("ar_title", this.editform.ar_title);
        data.append("en_title", this.editform.en_title);
        data.append("ar_description", this.editform.ar_description);
        data.append("en_description", this.editform.en_description);
        data.append("file", this.editform.file);
        await this.axios
          .post(`journals/${this.editform.id}`, data,{
            onUploadProgress: progressEvent => {
              this.precentage =
                (progressEvent.loaded / progressEvent.total) * 100;
            }
          })
          .then((res) => {
              this.gS();
            if (res.data.errors) {
              this.errorToast();
            } else {
              this.makeToast(
                "success",
                "update Success",
                "Your update is done successfully"
              );
            }
            this.precentage=0
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "warning",
                "update failed",
                "you don't a permision to do this action ;)"
              );
            } else {
              this.errorToast();
            }
          });
          this.rEF()
      },
      async aNM() {
        let data = new FormData();
        data.append("ar_title", this.form.ar_title);
        data.append("en_title", this.form.en_title);
        data.append("ar_description", this.form.ar_description);
        data.append("en_description", this.form.en_description);
        data.append("file", this.form.file);
        await this.axios
          .post(`journals`, data,{
            onUploadProgress: progressEvent => {
              this.precentage =
                (progressEvent.loaded / progressEvent.total) * 100;
            }
          })
          .then((res) => {
              this.gS();
            if (res.data.errors) {
              this.errorToast();
            } else {
              this.makeToast(
                "success",
                "update Success",
                "Your model is added successfully"
              );
            }
            this.rF();
            this.precentage=0
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "warning",
                "update failed",
                "you don't a permision to do this action ;)"
              );
            } else {
              this.errorToast();
            }
          });
        this.rF();
      },
     
      rF() {
        this.form.ar_title = ""
        this.form.en_title = ""
        this.form.ar_description = ""
        this.form.en_description = ""
        this.form.file = ""
      },
      rEF() {
        this.editform.ar_title = ""
        this.editform.en_title = ""
        this.editform.ar_description = ""
        this.editform.en_description = ""
        this.editform.file = ""
        this.editform.id = "";
      },
      async dM() {
        await this.axios
          .delete(`journals/${this.editform.id}`)
          .then((res) => {
            if (res.data.errors) {
              this.errorToast();
            } else {
              this.gS();
              this.makeToast(
                "success",
                "Delete Success",
                "Your item is deleted successfully"
              );
            }
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "warning",
                "update failed",
                "you don't a permision to do this action ;)"
              );
            } else {
              this.errorToast();
            }
          });
      },
      errorToast() {
        this.makeToast(
          "danger",
          "update failed",
          "some thing want wrong, i`m sorry :("
        );
      },
      eRM(item) {
        this.editform.ar_title = item.ar_title;
        this.editform.en_title = item.en_title;
        this.editform.ar_description = item.ar_description;
        this.editform.en_description = item.en_description;
        this.editform.file = item.image;
        this.editform.id = item.id;
      },
      dRM(item) {
        this.editform.title = item.title;
        this.editform.id = item.id;
      },
      check() {
        setTimeout(() => this.gS(), 1000);
      },
      ID() {
        this.teacher_id = localStorage.getItem("NisourTeacherId");
      },
      async gS() {
        await this.axios
          .get(
            `contact?take=${this.perPage}&skip=${this.currentPage - 1}&title=${
              this.title
            }` 
          )
          .then((res) => {
            this.items = [];
            this.totalRows = res.data.totalCount;
            this.items = res.data.items;
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "danger",
                "update failed",
                "you don't a permision to do this action ;)"
              );
            } else {
              this.errorToast();
            }
          });
      },
      makeToast(variant = null, title = null, body = null) {
        this.$bvToast.toast(body, {
          title: title,
          variant,
          solid: false,
        });
      },
      resetSearch() {
        this.title = "",
        this.category_id = "",
        this.subtype_id= "",
        this.type_id= "",
        this.carency_id= "",
        this.todate= "",
        this.fromdate= "",
        this.gS();
      },
      selectFileForForm(e) {
        this.form.file = "";
        console.log(e.target.files);
        console.log(e.target.files[0]);
        this.form.file = e.target.files[0];
        console.log(this.form.files);
      },
      selectFileForEditForm(e) {
        this.editform.file = "";
        console.log(e.target.files);
        console.log(e.target.files[0]);
        this.editform.file = e.target.files[0];
        console.log(this.editform.file);
      },
      onClicked(path) {
        console.log(path)
        window.open(`${filesUrl}/${path}`, "_blank");
      },
      getImage(path) {
      return `${filesUrl}/${path}`;
    },
    },
  };
  </script>
  